/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste!
 *	> 'dexie' import is restricted from being used. Importing from dexie is allowed but needs an additional approver */
import Dexie, { type IndexableType, type Table } from "dexie";

import { logGreyError } from "owa-analytics";
import type { MailboxInfo } from "owa-client-types";
import type { SessionData } from "owa-service/lib/types/SessionData";

const INDEXED_DB_NAME = "placesSession";
export interface PlacesSessionData {
    ownerId: string; // owner
    sessionData: SessionData;
    timestamp: number; // to store the last updated time
}

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Function Dexie called at module scope is not allowed. This may cause unwanted side effects. */
export const db: Dexie = new Dexie(INDEXED_DB_NAME);

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function stores called at module scope is not allowed. This may cause unwanted side effects.
 *	> Function version called at module scope is not allowed. This may cause unwanted side effects. */
db.version(1).stores({
    sessionData: "ownerId",
});

export const placesSessionDataTable: Table<PlacesSessionData, IndexableType, PlacesSessionData> = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function table called at module scope is not allowed. This may cause unwanted side effects. */
db.table<PlacesSessionData>("sessionData");

export async function deletePlacesSessionDatabase(mailboxInfo?: MailboxInfo): Promise<void> {
    if (await Dexie.exists(INDEXED_DB_NAME)) {
        try {
            if (db.isOpen()) {
                db.close(); // Have to close the database before deleting, otherwise InvalidStateError will be thrown.
            }
        }
        catch (err) {
            logGreyError("PlacesCloseDatabaseError", mailboxInfo, err as Error, {
                dbName: INDEXED_DB_NAME,
            });
        }
        await Dexie.delete(INDEXED_DB_NAME);
    }
}
